import { createStore } from "vuex";
import elearning from "./elearning/index.js";
import information from "./information/index.js";
import checkUser from "./checkUser/index.js";
import _axios from "@/plugins/axios";

export default createStore({
  state: {
    _list_yearTerm: [],
  },
  getters: {
    _list_yearTerm: (state) => state._list_yearTerm,
  },
  mutations: {},
  actions: {
    _list_yearTerm(context, param) {
      return _axios.post("/information/_list_yearTerm", param).then((res) => {
        context.state._list_yearTerm = res.data;
        return res.data;
      });
    },
  },
  modules: {
    elearning,
    information,
    checkUser,
  },
});
